import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-banner-features',
  templateUrl: './banner-features.component.html',
  styleUrls: ['./banner-features.component.scss']
})
export class BannerFeaturesComponent implements OnInit {

  @Input() bannerFeatures : any;
  path = "../../../../assets/images/"

  constructor() { }


  ngOnInit(): void {
  }

}
